import React from "react";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";

import CurrentPlayers from "../components/CurrentPlayers";
import TriviaSubmit from "assets/images/sbs/TriviaSubmit.png";

const ChooseAsker = ({ users, mobile_app, chooseasker_params }) => {
  const current_players_label = _.get(
    chooseasker_params,
    "current_players_label",
    "Current Players:"
  );
  const other_text = _.get(
    chooseasker_params,
    "other_text",
    "The Host is choosing a player to ask the question."
  );

  const divVariants = {
    hidden: {},
    visible: {},
    exit: {}
  };
  const imgVariants = {
    hidden: {
      y: "-100vh",
      opacity: 0.5,
      scale: 0.7
    },
    visible: {
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        type: "tween",
        duration: 0.2,
        opacity: { delay: 0.2, duration: 0.3 },
        scale: { delay: 0.2, duration: 0.3 }
      }
    }
  };
  const textVariants = {
    hidden: { opacity: 0.4, scale: 0.2 },
    visible: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.2 }
  };

  return (
    <div className="container">
      <motion.div
        variants={divVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="Lightning-trivia-Wrapper hostChoosing"
      >
        <motion.img
          variants={imgVariants}
          src={TriviaSubmit}
          className="logoimage"
          alt="sbsLogo"
        />
        <motion.h2 variants={textVariants} className="mediamText blueText">
          {other_text}
        </motion.h2>
        <motion.h3 variants={textVariants} className="mediamText blueText mb16">
          {current_players_label}
        </motion.h3>
        <CurrentPlayers users={users} mobile_app={mobile_app} />
      </motion.div>
    </div>
  );
};

export default ChooseAsker;
